var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 228.261,
    viewBox: "0 0 233 228.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1052 -443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(217 68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(844.535 335.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.819V11.639H0Z",
    transform: "translate(0 4.114) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.657 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.383 142.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.479,44.208a8.729,8.729,0,1,1,8.729-8.729A8.74,8.74,0,0,1,35.479,44.208Zm0-11.639a2.91,2.91,0,1,0,2.91,2.91A2.914,2.914,0,0,0,35.479,32.569Z",
    transform: "translate(-6.75 -1.75)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(833.035 334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.468,109.245C180.459,75.546,182.8,41,172.19,24.761S129.965-19.483,55.264,29.312s-55.7,101.837-44.028,119.7C65.866,232.642,241.451,168.927,202.468,109.245Z",
    transform: "translate(-0.134 -1.91)",
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 9.5,
    rx: 116.5,
    ry: 9.5,
    transform: "translate(821 543.261)",
    fill: "#f5f5f5",
    opacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1272.543 554.311)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2387.067 -48.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,313.2v14.126a1.578,1.578,0,0,0,1.576,1.576H45.5a1.578,1.578,0,0,0,1.576-1.576V302.471L39.141,310.4A9.622,9.622,0,0,1,33,313.2Z",
    transform: "translate(-27.092 -254.882)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,301.471V326.5a1.578,1.578,0,0,0,1.576,1.575H154.5a1.578,1.578,0,0,0,1.575-1.575V311.766a9.52,9.52,0,0,1-6.571-2.793Z",
    transform: "translate(-116.576 -254.062)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,287.139v16.292a1.578,1.578,0,0,0,1.576,1.576H263.5a1.578,1.578,0,0,0,1.575-1.576V273.371l-12.515,12.515A9.389,9.389,0,0,1,251,287.139Z",
    transform: "translate(-206.061 -230.992)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.016,170.171,360,183.187v35.521a1.578,1.578,0,0,0,1.576,1.576H372.5a1.578,1.578,0,0,0,1.576-1.576V171.156c-.358-.3-.627-.573-.824-.752Z",
    transform: "translate(-295.546 -146.269)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,37.512a3.043,3.043,0,0,0-2.31-.841h-.286c-5.085.233-10.151.483-15.236.716a3.288,3.288,0,0,0-2.345.806,2.668,2.668,0,0,0-.555.824,2.633,2.633,0,0,0,.806,3.187l1.271,1.289c.877.9,1.772,1.79,2.668,2.668L39.693,76.9l-13.8-13.8a4.387,4.387,0,0,0-6.213,0L1.289,81.467a4.387,4.387,0,0,0,0,6.213l.824.824a4.387,4.387,0,0,0,6.213,0L22.774,74.054l13.8,13.8a4.409,4.409,0,0,0,6.231,0L77.47,53.2l3.921,3.9a2.97,2.97,0,0,0,2.095,1.11,2.592,2.592,0,0,0,1.253-.34,3.409,3.409,0,0,0,.752-.555,3.64,3.64,0,0,0,.949-2.524c.143-3.294.3-6.589.466-9.9l.233-4.959A3.081,3.081,0,0,0,86.4,37.512Z",
    transform: "translate(0 -36.671)",
    fill: "#e7e7f2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbInsights);
export default __webpack_public_path__ + "static/media/fb-insights.ab1767edd3c04c6fdeb5c4c9f3246812.svg";
export { ForwardRef as ReactComponent };